import { render, staticRenderFns } from "./RecordHistory.vue?vue&type=template&id=bc9d0638&scoped=true"
import script from "./RecordHistory.vue?vue&type=script&lang=js"
export * from "./RecordHistory.vue?vue&type=script&lang=js"
import style0 from "./RecordHistory.vue?vue&type=style&index=0&id=bc9d0638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9d0638",
  null
  
)

export default component.exports